import component from './feed.vue'

export default component
